import router from '@/router'
export default {
    namespaced: true,
    state: {
        user: null,
        errors: {
            updateUser: {},
            updateLegal: {},
            updatePassword: {}
        }
    },
    getters: {
        isRetailer({ user }) {
            return user && !!user.retailer
        },
        isSupplier({ user }) {
            return user && !!user.supplier
        },
        isDemoUser({ user }) {
            return user && !!user.is_demo
        },
        user({ user }) {
            return user
        }
    },
    mutations: {
        SET_USER(state, user) {
            state.user = user
        },
        DELETE_USER(state) {
            state.user = null
        },
        SET_ERRORS(state, error) {
            state.errors[error.key] = error.val
        }
    },
    actions: {
        setUser({ commit }, user) {
            commit('SET_USER', user)
            if (user.retailer) router.push('/retailer')
            if (user.supplier) router.push('/supplier')
        },
        async getUser({ commit }) {
            const user = await this.$axios
                .get('/user')
                .then(res => res.data.user)
                .catch(e => {
                    console.log('Ошибка ' + e.message)
                })
            if (user) {
                commit('SET_USER', user)
            }
        },
        async updateLegal({ commit }, data) {
            commit('SET_ERRORS', {
                key: 'updateLegal',
                val: ''
            })

            const user = await this.$axios
                .patch('/user/update-legal', data)
                .then(res => res.data.user)
                .catch(e => {
                    console.log('Ошибка ' + e.message)
                    if (e.response) {
                        console.log(e.response.data)
                        commit('SET_ERRORS', {
                            key: 'updateLegal',
                            val: e.response.data
                        })
                    }
                })
            if (user) {
                commit('SET_USER', user)
            }
        },
        async updateUser({ commit }, data) {
            commit('SET_ERRORS', {
                key: 'updateUser',
                val: ''
            })

            const user = await this.$axios
                .patch('/user/update', data)
                .then(res => res.data.user)
                .catch(e => {
                    console.log('Ошибка ' + e.message)
                    if (e.response) {
                        console.log(e.response.data)
                        commit('SET_ERRORS', {
                            key: 'updateUser',
                            val: e.response.data
                        })
                    }
                })
            if (user) {
                commit('SET_USER', user)
            }
        },
        async updatePassword({ commit }, data) {
            commit('SET_ERRORS', {
                key: 'updatePassword',
                val: ''
            })

            try {
                const resp = await this.$axios.patch(
                    '/user/update-password',
                    data
                )
                return resp.data
            } catch (e) {
                console.log('Ошибка ' + e.message)
                if (e.response) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'updatePassword',
                        val: e.response.data
                    })
                }
            }
        }
    }
}
